const skills = [
  {
    name: "Manual Testing",
    color: "bg-emerald-200",
    textColor: "text-emerald-900",
    darkBgColor: "dark:bg-emerald-700",
    darkTextColor: "dark:text-emerald-100",
  },
  {
    name: "Test Case Design",
    color: "bg-cyan-200",
    textColor: "text-cyan-900",
    darkBgColor: "dark:bg-cyan-700",
    darkTextColor: "dark:text-cyan-100",
  },
  {
    name: "Bug Reporting",
    color: "bg-rose-200",
    textColor: "text-rose-900",
    darkBgColor: "dark:bg-rose-700",
    darkTextColor: "dark:text-rose-100",
  },
  {
    name: "Regression Testing",
    color: "bg-indigo-200",
    textColor: "text-indigo-900",
    darkBgColor: "dark:bg-indigo-700",
    darkTextColor: "dark:text-indigo-100",
  },
  {
    name: "API Testing",
    color: "bg-sky-200",
    textColor: "text-sky-900",
    darkBgColor: "dark:bg-sky-700",
    darkTextColor: "dark:text-sky-100",
  },
  {
    name: "Jira",
    color: "bg-blue-200",
    textColor: "text-blue-900",
    darkBgColor: "dark:bg-blue-700",
    darkTextColor: "dark:text-blue-100",
  },
  {
    name: "Playwright",
    color: "bg-lime-200",
    textColor: "text-lime-900",
    darkBgColor: "dark:bg-lime-700",
    darkTextColor: "dark:text-lime-100",
  },
  {
    name: "Postman",
    color: "bg-orange-200",
    textColor: "text-orange-900",
    darkBgColor: "dark:bg-orange-700",
    darkTextColor: "dark:text-orange-100",
  },
  {
    name: "SQL",
    color: "bg-lime-200",
    textColor: "text-lime-800",
    darkBgColor: "dark:bg-lime-600",
    darkTextColor: "dark:text-lime-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1737047781/sql_zb4hoz.png",
  },
  {
    name: "VueJs",
    color: "bg-yellow-200",
    textColor: "text-yellow-800",
    darkBgColor: "dark:bg-yellow-600",
    darkTextColor: "dark:text-yellow-200",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Vue.js_Logo_2.svg/1184px-Vue.js_Logo_2.svg.png",
  },
  {
    name: "JavaScript",
    color: "bg-blue-200",
    textColor: "text-blue-800",
    darkBgColor: "dark:bg-blue-600",
    darkTextColor: "dark:text-blue-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791971/logo/javascript_tlgwab.png",
  },
  {
    name: "REST APIs",
    color: "bg-indigo-200",
    textColor: "text-indigo-800",
    darkBgColor: "dark:bg-indigo-600",
    darkTextColor: "dark:text-indigo-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791980/logo/rest_akneqe.png",
  },
];

export default skills;
